var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectWizardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16667 1.75002H15.8333V9.66669H3.16667V1.75002ZM15.8333 11.25C16.2533 11.25 16.656 11.0832 16.9529 10.7863C17.2499 10.4893 17.4167 10.0866 17.4167 9.66669V1.75002C17.4167 0.87127 16.7042 0.166687 15.8333 0.166687H3.16667C2.28792 0.166687 1.58333 0.87127 1.58333 1.75002V9.66669C1.58333 10.0866 1.75015 10.4893 2.04708 10.7863C2.34401 11.0832 2.74674 11.25 3.16667 11.25H0V12.8334H19V11.25H15.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectWizardIcon);
export default __webpack_public_path__ + "static/media/project-wizard-icon.de1e533d.svg";
export { ForwardRef as ReactComponent };